import React, { createContext } from "react";

import useAuth from "@/hooks/useLocalStorage";

const Context = createContext();

function AuthProvider({ children }) {
	const {
		authenticated,
		type,
		loading,
		handleLogin,
		handleLogout,
	} = useAuth();

	return (
		<Context.Provider
			value={{ loading, authenticated, type, handleLogin, handleLogout }}>
			{children}
		</Context.Provider>
	);
}

export { Context, AuthProvider };
